/* eslint-disable react/jsx-filename-extension */
import {
  ChatBotOutlinedV2 as ChatBotOutlined,
  Google,
  Messenger,
  Instagram,
  InstagramSolid,
  Outlook,
} from '@groovehq/internal-design-system/lib/assets/icons'
import thumbsUpImg from '@groovehq/internal-design-system/lib/assets/images/thumbs-up.png'
import gmailImg from '@groovehq/internal-design-system/lib/assets/images/auth-gmail.png'
import {
  DRAWER_TYPE_CHANNELS_SELECT_EMAIL,
  DRAWER_TYPE_CHANNELS_CHANNEL_DETAILS_OAUTH_MODAL,
  DRAWER_TYPE_CHANNELS_CHANNEL_DETAILS_OAUTH,
  DRAWER_TYPE_CHANNELS_AUTHENTICATE,
  DRAWER_TYPE_CHANNELS_EMAIL_FORWARD,
  DRAWER_TYPE_CHANNELS_ADD_LIVE_CHAT,
  DRAWER_TYPE_CHANNELS_AUTHENTICATE_IMAP,
  DRAWER_TYPE_CHANNELS_FORWARDING_DETAILS,
  DRAWER_TYPE_CHANNELS_SELECT_GOOGLE_WORKSPACE_EMAIL,
  DRAWER_TYPE_CHANNELS_SELECT_GOOGLE_FORWARDING_OPTION,
} from 'ducks/drawers/types'
import {
  DRAWER_ID_FOLDERS_SELECT_EMAIL,
  DRAWER_ID_FOLDERS_CHANNEL_DETAILS,
  DRAWER_ID_FOLDERS_CHANNEL_DETAILS_OAUTH,
  DRAWER_ID_FOLDERS_CHANNELS_AUTHENTICATE,
  DRAWER_ID_FOLDERS_CHANNELS_EMAIL_FORWARD,
  DRAWER_ID_FOLDERS_CHANNELS_ADD_LIVE_CHAT,
} from 'ducks/drawers/ids'
import { doSelectChatChannel } from 'ducks/channels/actions'
import {
  emailClosed as EmailClosed,
  emailClosedV2 as EmailClosedV2,
  emailV2 as EmailV2,
  chatsV2 as LiveChat,
  officeLogo as OfficeLogo,
  googleGroups as GoogleGroups,
  gmail as Gmail,
} from 'assets/icons/groove/v2'
import { doOpenNewWidgetPage } from 'subapps/settings/actions/redirect'

export const CHANNEL_MAIN_TYPES = {
  email: {
    drawer: {
      id: DRAWER_ID_FOLDERS_SELECT_EMAIL,
      type: DRAWER_TYPE_CHANNELS_SELECT_EMAIL,
      closeIgnoresStack: true,
    },
    name: 'Email',
    icon: <EmailV2 />,
    title: `Email`,
    description:
      'Connect your Gmail account or forward from any other email address.',
  },
  chat: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_ADD_LIVE_CHAT,
      type: DRAWER_TYPE_CHANNELS_ADD_LIVE_CHAT,
      closeIgnoresStack: true,
    },
    doBeforeDrawer: doSelectChatChannel,
    name: 'Live Chat',
    icon: <LiveChat />,
    title: 'Live Chat',
    description:
      'Interact in real-time with customers on any page of your website or app.',
  },
  facebook: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNEL_DETAILS_OAUTH,
      type: DRAWER_TYPE_CHANNELS_CHANNEL_DETAILS_OAUTH,
      closeIgnoresStack: true,
    },
    editDrawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_AUTHENTICATE,
      type: DRAWER_TYPE_CHANNELS_AUTHENTICATE,
      closeIgnoresStack: true,
    },
    name: 'Messenger',
    icon: <Messenger />,
    title: 'Messenger',
    description:
      'Connect your Facebook Page to handle incoming Messenger chats.',
    brandColor: '#0084ff',
  },
  instagram: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNEL_DETAILS_OAUTH,
      type: DRAWER_TYPE_CHANNELS_CHANNEL_DETAILS_OAUTH,
    },
    editDrawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_AUTHENTICATE,
      type: DRAWER_TYPE_CHANNELS_AUTHENTICATE,
      closeIgnoresStack: true,
    },
    name: 'Instagram',
    icon: <Instagram />,
    solidIcon: <InstagramSolid />,
    title: 'Instagram',
    description:
      'Connect your Instagram account to handle incoming direct messages.',
    brandColor: '#0495f6',
  },
}

export const CHANNEL_EMAIL_TYPES = {
  google: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNEL_DETAILS_OAUTH,
      type: DRAWER_TYPE_CHANNELS_CHANNEL_DETAILS_OAUTH_MODAL,
      closeIgnoresStack: true,
    },
    editDrawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_AUTHENTICATE,
      type: DRAWER_TYPE_CHANNELS_AUTHENTICATE,
      closeIgnoresStack: true,
    },
    name: 'Gmail',
    icon: <Google />,
    headerImg: gmailImg,
    title: 'Google Workspace Account',
    editTitle: 'Link your Gmail account',
    description:
      'Receive your Google Workspace Account emails directly in Groove ',
    importHistory: true,
    company: 'Google',
    totalStepCount: 4,
    type: 'google',
  },
  forwarding: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNEL_DETAILS,
      type: DRAWER_TYPE_CHANNELS_FORWARDING_DETAILS,
      closeIgnoresStack: true,
    },
    editDrawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_EMAIL_FORWARD,
      type: DRAWER_TYPE_CHANNELS_EMAIL_FORWARD,
      closeIgnoresStack: true,
    },
    name: 'Other email',
    icon: <EmailClosedV2 />,
    headerImg: thumbsUpImg,
    totalStepCount: 4,
    title: 'Other email provider',
    editTitle: 'Forward your emails to Groove',
    description: 'Receive emails from other email providers directly in Groove',
    type: 'forwarding',
  },
}

export const CHANNEL_EMAIL_OPTIONS = {
  google: {
    ...CHANNEL_EMAIL_TYPES.google,
    drawer: {
      type: DRAWER_TYPE_CHANNELS_CHANNEL_DETAILS_OAUTH_MODAL,
      closeIgnoresStack: true,
    },
    name: 'Google',
    icon: <Google />,
    headerImg: gmailImg,
    title: 'Connect Gmail',
    editTitle: 'Link your Gmail account',
    description:
      'Start recieving your GSuite or Gmail email directly in Groove',
    importHistory: true,
    company: 'Google',
    totalStepCount: 3,
    provider: 'google',
    secondaryTypes: {
      google: {
        ...CHANNEL_EMAIL_TYPES.google,
        drawer: {
          type: DRAWER_TYPE_CHANNELS_SELECT_GOOGLE_WORKSPACE_EMAIL,
        },
        secondaryTypes: {
          google: {
            ...CHANNEL_EMAIL_TYPES.google,
            recommended: true,
            title: 'Connect with Google Workspace',
            description:
              'Over 95% of Google Workspace accounts connect email inbox(es) to Groove this way',
          },
          forwarding: {
            ...CHANNEL_EMAIL_TYPES.forwarding,
            drawer: {
              type: DRAWER_TYPE_CHANNELS_SELECT_GOOGLE_FORWARDING_OPTION,
            },
            title: 'Set up a Forwarding Rule',
            description:
              'Less than 5% of Google Workspace accounts connect email inbox(es) to Groove this way',
          },
        },
      },
      googleGroup: {
        ...CHANNEL_EMAIL_TYPES.forwarding,
        icon: <GoogleGroups className="grui p-3" />,
        title: 'Google Group',
        description: 'Receive your Google Group emails directly in Groove',
      },
      googleAlias: {
        ...CHANNEL_EMAIL_TYPES.forwarding,
        icon: <Gmail className="grui p-3" />,
        title: ' Google Alias',
        description: 'Receive your Google Alias emails directly in Groove',
      },
    },
  },
  forwarding: {
    ...CHANNEL_EMAIL_TYPES.forwarding,
  },
}

export const CHANNEL_ADDITIONAL_TYPES = {
  contact_widget: {
    doBeforeDrawer: doOpenNewWidgetPage,
    name: 'Contact widget',
    icon: <ChatBotOutlined />,
    title: 'Contact widget',
    description: 'Set up a contact widget for your website or app.',
  },
}

export const CHANNEL_TYPES = {
  ...CHANNEL_MAIN_TYPES,
  ...CHANNEL_EMAIL_TYPES,
  outlook: {
    editDrawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_AUTHENTICATE,
      type: DRAWER_TYPE_CHANNELS_AUTHENTICATE,
      closeIgnoresStack: true,
    },
    name: 'Outlook',
    icon: <Outlook className="grui p-2" />,
    headerImg: thumbsUpImg,
    title: 'Connect Outlook',
    editTitle: 'Link up your Outlook account',
    description: 'Start recieving your Outlook email directly in Groove',
    importHistory: true,
    company: 'Microsoft',
    totalStepCount: 4,
  },
  office365: {
    editDrawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_AUTHENTICATE,
      type: DRAWER_TYPE_CHANNELS_AUTHENTICATE,
      closeIgnoresStack: true,
    },
    name: 'Microsoft 365',
    icon: <OfficeLogo className="grui p-3" />,
    iconBig: <OfficeLogo className="grui p-5" />,
    headerImg: thumbsUpImg,
    title: 'Connect Microsoft 365',
    editTitle: 'Link up your Microsoft 365 account',
    description: 'Start recieving your Microsoft 365 email directly in Groove',
    importHistory: true,
    company: 'Microsoft',
    totalStepCount: 4,
  },
  imap: {
    editDrawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_AUTHENTICATE,
      type: DRAWER_TYPE_CHANNELS_AUTHENTICATE_IMAP,
      closeIgnoresStack: true,
    },
    name: 'IMAP',
    icon: <EmailClosed />,
    isSecondaryType: true,
    headerImg: thumbsUpImg,
    title: 'Connect IMAP',
    editTitle: 'Link up your IMAP account',
    description: 'Start recieving your IMAP email directly in Groove',
    importHistory: true,
    company: 'The email provider',
    totalStepCount: 4,
  },
}

export const drawerConfig = {
  DEFAULT_DRAWER_TITLE: `New ${app.t('mailbox')}`,
}
